export enum CommentLoaderKey {
  LIST_COMMENTS = 'comment-list',
  CREATE_COMMENT = 'comment-create',
}

export enum CommentResourceType {
  ORDER = 'order',
  SUPPLY_NETWORK = 'supply-network',
  INVENTORY = 'inventory',
  FORECAST = 'forecastFile',
  SHIPMENT = 'shipment'
}
